module.exports = __webpack_public_path__ + "static/media/AB_iPad_SE_SV.7e04ba2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_iPad_SE_SV.png
// module id = 114
// module chunks = 0